import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { push } from 'react-router-redux';
import { Grid } from "@material-ui/core";

import _ from 'lodash';
import 'rc-tooltip/assets/bootstrap_white.css'
import Tooltip from 'rc-tooltip'
import IconButton from 'material-ui/IconButton'
import ActionInfo from 'material-ui/svg-icons/action/info'

import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import MenuItem from 'material-ui/MenuItem/MenuItem';
import Toggle from 'material-ui/Toggle';
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from 'material-ui/Table';

import {
	getAllCampaigns,
	getCampaignById,
	updateCampaign
} from '../../reducers/campaign/resources';
import templateResources from '../../reducers/templates/resources';
import { getUserProducts } from '../../reducers/products/resources';
import session from '../../utils/session';
import mixpanel from '../../utils/mixpanel';
import config from '../../config';
class Campaigns extends Component {
	componentWillMount = async () => {
		this.setState({
			campaigns: [],
			rawCampaignList: [],
			templates: [],
			campaignId: '',
			templateId: '',
			campaignName: '',
			deleteId: '',
			showCampaignError: false,
			showConfirmModal: false,
			showEditModal: false,
			showSnackBar: false,
			snackBarMessage: '',
			hasAccess: false
		});

		const userRole = session.get('userData').role || '';
		const campaignResponse = await getAllCampaigns();
		const templateResponse = await templateResources.getTemplates();

		let userproducts = await getUserProducts();
		userproducts = userproducts.data;

		const userProduct = _.find(userproducts, p => {
			return p.product.services.includes('broadcast-campaign');
		});

		const isAdmin = userRole === config.userRoles.ghAdmin;
		this.setState({
			isAdmin,
			rawCampaignList: campaignResponse.data,
			templates: templateResponse.data,
			hasAccess: userProduct || isAdmin ? true : false
		});
		this.filterAllCampaigns(this.props.selectedCompany);
	};

	componentWillReceiveProps(nextProps) {
		this.filterAllCampaigns(nextProps.selectedCompany);
	};

	filterAllCampaigns = selectedCompany => {
		let campaigns;

		if(selectedCompany) {
			campaigns = this.state.rawCampaignList.filter(campaign => campaign.company_id === selectedCompany);
		} else {
			campaigns = this.state.rawCampaignList;
		};

		this.setState({ campaigns });
	};

	handleClose = () =>
		this.setState({
			showSnackBar: false,
			snackBarMessage: ''
		});

	editCampaign = campaignId => async (event, i, value) => {
		event.preventDefault();
		mixpanel.track('broadcast campaign:edit campaign');

		const response = await getCampaignById(campaignId, {"field": "all"}, '{}', {});

		if (response) {
			this.setState({
				showEditModal: true,
				campaignName: response.data.name,
				campaignId: response.data.id,
				templateId: response.data.template ? response.data.template.id : '',
				scheduleDate: '',
				campaignStatus: ''
			});
		}
	};

	changeIsActive = campaignId => async (event, value) => {
		const data = {
			is_active: value
		};

		try {
			await updateCampaign(campaignId, data);

			const campaigns = await getAllCampaigns();
			this.setState({
				rawCampaignList: campaigns.data,
				showSnackBar: true,
				snackBarMessage: 'Update successful'
			});
			this.filterAllCampaigns(this.props.selectedCompany);
		} catch (error) {
			this.setState({
				showSnackBar: true,
				snackBarMessage: 'Error in updating campaign'
			});
		}
	};

	render = () => {
		const styles = {
			gridFluid: {
				height: '100%',
				backgroundColor: '#FBFBFB',
				overflow: 'hidden auto'
			},
			raisedButton: {
				marginTop: '10px'
			},
			spacer: {
				marginLeft: '5px',
				marginRight: '5px'
			},
			style4: {
				margin: 7
			}
		};

		let campaigns = [];
		this.state.campaigns.map(campaign => {
			let { accepted_count, delivered_count, expired_count, failed_count, noOfContacts, contact_group_cnt } = campaign;
			
			accepted_count=parseInt(accepted_count || 0)
			delivered_count=parseInt(delivered_count || 0)
			expired_count=parseInt(expired_count || 0)
			failed_count=parseInt(failed_count || 0)
			noOfContacts=parseInt(noOfContacts || contact_group_cnt || 0)
			
			const totalSent = accepted_count+delivered_count
			const totalFailed = expired_count+failed_count
			const totalUnkown = noOfContacts -(totalFailed+totalSent)
			
			let campaignStatus = 'Sent';
			if (campaign.status === false) {
				campaignStatus = 'Scheduled';
			} else if (campaign.status === null) {
				campaignStatus = 'On Hold';
			}
			if (campaign.is_inprogress) {
				campaignStatus = 'Sending';
			}

			if (!campaign.hasCampaignBot) {
				campaignStatus = 'No campaign bot'
			}

			
			const showNumbers = ['Sent','Sending'].includes(campaignStatus);

			let reviewStatus = null;
			const rowColumn = [];
			if (this.state.isAdmin) {
				reviewStatus = (
					<Toggle
						toggled={campaign.is_active}
						onToggle={this.changeIsActive(campaign.id)}
					/>
				);

				rowColumn.push(<TableRowColumn>{campaign.username}</TableRowColumn>);
				rowColumn.push(<TableRowColumn>{campaign.companyName}</TableRowColumn>);
			} else {
				reviewStatus = campaign.is_active ? 'Approved' : 'Pending';

				let msg = campaign.message;
				if (campaign.message.length > 50) {
					msg = `${msg.slice(0, 50)}...`;
				}

				rowColumn.push(
					<TableRowColumn key={campaign.id}>{msg}</TableRowColumn>
				);
			}

			campaigns.push(
        <TableRow key={campaign.id}>
          <TableRowColumn>{campaign.name}</TableRowColumn>
          {rowColumn}
          <TableRowColumn>{campaign.schedule}</TableRowColumn>
          <TableRowColumn style={{ textAlign: "center" }}>
            {noOfContacts} 
          </TableRowColumn>
          {/* <TableRowColumn>{sent_count}</TableRowColumn> */}
          <TableRowColumn style={{ textAlign: "center" }}>
			<div style={{display:'flex', direction:'row', alignItems:'center'}}>
			{accepted_count>0?(
			<Tooltip
              placement="right"
              trigger={["hover"]}
              overlay={
                <span style={{ whiteSpace: "pre-line" }}>
                  {accepted_count} message(s) awaiting carrier confirmation.
                </span>
              }
            >
              <IconButton className="message-status-btn">
                <ActionInfo color="#ccc" className="message-status-btn-icon" />
              </IconButton>
            </Tooltip>
			):<div style={{width:'48px',height:'48px',display:'block'}}></div>}
			{showNumbers ? totalSent: '-'}
			</div>
            
          </TableRowColumn>
          <TableRowColumn style={{ textAlign: "center" }}>
            {showNumbers? totalFailed + totalUnkown : '-'}
          </TableRowColumn>
          <TableRowColumn
            style={{
              width: "10%",
              textAlign: "center",
              paddingLeft: "24px",
              paddingRight: "0px",
            }}
          >
            {campaignStatus}
          </TableRowColumn>
          <TableRowColumn
            className="review-status-column"
            style={{ width: "10%", paddingLeft: "48px" }}
          >
            {reviewStatus}
          </TableRowColumn>
          <TableRowColumn style={{ textAlign: "center" }}>
            <RaisedButton
              label="View"
              onClick={this.props.goTo(`/campaign/${campaign.id}`)}
              primary={true}
              style={{ minWidth: "unset" }}
            />
          </TableRowColumn>
        </TableRow>
      );
		});

		let templateOptions = [];
		this.state.templates.map(template => {
			templateOptions.push(
				<MenuItem
					key={template.id}
					value={template.id}
					primaryText={template.name}
				/>
			);
		});

		const headerColumns = {
			isAdmin: ['Username', 'Company Name'],
			notAdmin: ['Message']
		};
		let tableHeaderColumns = [];
		const headerStatus = this.state.isAdmin
			? headerColumns.isAdmin
			: headerColumns.notAdmin;
		headerStatus.forEach(header => {
			tableHeaderColumns.push(
				<TableHeaderColumn key={header}>{header}</TableHeaderColumn>
			);
		});

		return (
			<Grid fluid style={styles.gridFluid}>
				<Snackbar
					open={this.state.showSnackBar}
					message={this.state.snackBarMessage}
					autoHideDuration={4000}
					onRequestClose={this.handleClose}
				/>
					<Row className="mb-50">
						<Col xs={12} className="text-center" style={styles.raisedButton}>
							<RaisedButton
								label="Create Broadcast"
								onClick={this.props.goTo('/campaign/create')}
								primary={true}
								style={styles.spacer}
								className="tour-broadcast-create-btn"
								// disabled={!this.state.hasAccess}
							/>
						</Col>
					</Row>
					<Row>
						<Col xs={12}>
							<h3>Existing Campaigns</h3>
						</Col>
					</Row>
					<Row
						className="campaign-list"
						style={{ height: '100%', overflow: 'auto' }}
					>
						<Col xs={12} className="tour-broadcast-list" style={{ padding: '10px 20px'}}>
							<div className="sitewide-card">
								<Table fixedHeader={true} height="50vh">
									<TableHeader
										displaySelectAll={false}
										adjustForCheckbox={false}
										enableSelectAll={false}
									>
										<TableRow>
											<TableHeaderColumn>Campaign Name</TableHeaderColumn>
											{tableHeaderColumns}
											<TableHeaderColumn>Schedule Date</TableHeaderColumn>
											<TableHeaderColumn>
												<center>
													No. of
													<br />
													Contacts
												</center>
											</TableHeaderColumn>
											{/* <TableHeaderColumn>
												<center>
													Msg.
													<br />
													Sent
												</center>
											</TableHeaderColumn> */}
											<TableHeaderColumn>
												<center>
													Msg.
													<br />
													Delivered
												</center>
											</TableHeaderColumn>
											<TableHeaderColumn>
												<center>
													Msg.
													<br />
													Failed
												</center>
											</TableHeaderColumn>
											<TableHeaderColumn style={{ width: '10%' }}>
												<center>
													Campaign
													<br />
													Status
												</center>
											</TableHeaderColumn>
											<TableHeaderColumn style={{ width: '10%' }}>
												<center>
													Review
													<br />
													Status
												</center>
											</TableHeaderColumn>
											<TableHeaderColumn style={{ textAlign: 'center' }}>
												Action
											</TableHeaderColumn>
										</TableRow>
									</TableHeader>
									<TableBody displayRowCheckbox={false}>{campaigns}</TableBody>
								</Table>
							</div>
						</Col>
					</Row>
			</Grid>
		);
	};
}

const mapStateToProps = state => {
	const { company: { selectedCompany } } = state;
	return { selectedCompany };
};

const mapDispatchToProps = dispatch => {
	return {
		goTo(path) {
			return () => {
				mixpanel.track(
					'broadcast campaign:change route',
					{ url: path }
				);

				dispatch(push(path));
			};
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Campaigns);
